import React, { ReactNode } from "react";

import { useIntl } from "react-intl";

import styles from "./NoData.module.scss";

interface Props {
  action?: ReactNode;
  imageSrc: string;
  showTitle?: boolean;
  text: ReactNode;
  title?: ReactNode;
}

const NoData = ({ action, imageSrc, showTitle = true, text, title }: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <img alt="No data" src={imageSrc} />
      {(title || showTitle) && (
        <div className={styles.title}>
          {title ??
            intl.formatMessage({
              id: "component.preview.noData.title",
              defaultMessage: "Nothing here yet.",
              description: "Title for a no data component",
            })}
        </div>
      )}
      <div className={styles.text}>{text}</div>
      {action}
    </div>
  );
};

export default NoData;
